import { useRefinementList } from 'react-instantsearch';

import InstantSearchAccordion from './units/instantSearchAccordion';
import InstantSearchFilterOption from './units/instantSearchFilterOption';
import InstantSearchFilterExplanation, {
  InstantSearchFilterExplanationProps,
} from './units/instantSearchFilterExplanation';

import type { FilterProps } from '@javascript/types/InstantSearch';

export interface MultiSelectFilterProps
  extends FilterProps,
    Partial<InstantSearchFilterExplanationProps> {
  labelFormatter?: (label: string) => string;
}

const MultiSelectFilter = ({
  attribute,
  explanation,
  labelFormatter,
  label,
  sortBy,
  filtersOpen,
}: MultiSelectFilterProps) => {
  const { items, refine } = useRefinementList({
    limit: 100,
    attribute,
    sortBy,
  });

  if (items.length === 0) return null;

  const selectedItems = items.filter((item) => item.isRefined);
  const selectedOptions = selectedItems
    .map((item) => (labelFormatter ? labelFormatter(item.label) : item.label))
    .join(', ');

  return (
    <InstantSearchAccordion
      filtersOpen={filtersOpen}
      label={label}
      selectedOptions={selectedOptions}
    >
      <ul>
        {items.map((item) => (
          <InstantSearchFilterOption.CheckBox
            count={item.count}
            id={`${attribute}-${item.label}`}
            isSelected={item.isRefined}
            key={`${attribute}-${item.label}`}
            label={labelFormatter ? labelFormatter(item.label) : item.label}
            onChange={() => refine(item.value)}
          />
        ))}
      </ul>
      {explanation && (
        <InstantSearchFilterExplanation explanation={explanation} />
      )}
    </InstantSearchAccordion>
  );
};

export default MultiSelectFilter;
